module.exports = __webpack_public_path__ + "static/media/fundcorp-logo.33b22706.svg";